import { createUseStyles } from "react-jss";

export default createUseStyles({
    pagination: {
        flexShrink: 0,
    },
});
